export default __webpack_public_path__ + "static/media/fried-pickle-labs.c3be6e90.svg";